import { StateEffect } from "@codemirror/state";
import { StateField } from "@codemirror/state";
import { ViewPlugin } from "@codemirror/view";

import { updateHasEffect } from "./utils/effects.js";

export const languageLoadedEffect = StateEffect.define();
export const hasLanguageLoadedEffect = updateHasEffect(languageLoadedEffect);
export const setMetadataEffect = StateEffect.define();

export const metadataState = StateField.define({
    create() {
        return undefined;
    },
    update(value, transaction) {
        for (const effect of transaction.effects) {
            if (effect.is(setMetadataEffect)) {
                return effect.value;
            }
        }

        return value;
    },
});

export function languageLoadedListener() {
    return ViewPlugin.define((view) => {
        window.setTimeout(() => {
            view.dispatch({
                effects: languageLoadedEffect.of(null),
            });
        });

        return {};
    });
}

export function setMetadata(values) {
    return {
        effects: setMetadataEffect.of(values),
    };
}
